
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.267 18.47l6.804-6.803-6.804-6.804v3.96H2.6v5.688h10.667v3.96zm9.066-6.803L11.667 22.333v-6.222H1V7.222h10.667V1l10.666 10.667z"}})])
          )
        }
      }
    